import { useState } from 'react';
import { api } from '../lib/api';
import { Alert, Button, Card, Field, Input } from '../components/ui';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    await api('/auth/password/forgot', { method: 'POST', body: { email } }).catch(() => undefined);
    setDone(true);
  };

  return (
    <div className="mx-auto flex min-h-full max-w-sm flex-col justify-center p-6">
      <Card title="Passwort zurücksetzen">
        {done ? (
          <Alert kind="success">
            Falls ein Konto existiert, wurde eine E-Mail mit weiteren Anweisungen versendet.
          </Alert>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <Field label="E-Mail">
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </Field>
            <Button type="submit" className="w-full">
              Link anfordern
            </Button>
          </form>
        )}
        <a href="/login" className="mt-4 block text-center text-sm text-brand-accent">
          Zurück zur Anmeldung
        </a>
      </Card>
    </div>
  );
}

export function ResetPasswordPage() {
  const token = new URLSearchParams(window.location.search).get('token') ?? '';
  const [password, setPassword] = useState('');
  const [state, setState] = useState<'idle' | 'done' | 'error'>('idle');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await api('/auth/password/reset', { method: 'POST', body: { token, password } });
      setState('done');
    } catch {
      setState('error');
    }
  };

  return (
    <div className="mx-auto flex min-h-full max-w-sm flex-col justify-center p-6">
      <Card title="Neues Passwort setzen">
        {state === 'done' ? (
          <Alert kind="success">
            Passwort geändert. <a className="underline" href="/login">Jetzt anmelden</a>.
          </Alert>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            {state === 'error' && <Alert>Token ungültig oder abgelaufen.</Alert>}
            <Field label="Neues Passwort (min. 10 Zeichen)">
              <Input
                type="password"
                minLength={10}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Field>
            <Button type="submit" className="w-full" disabled={!token}>
              Speichern
            </Button>
          </form>
        )}
      </Card>
    </div>
  );
}
